<template>
    <div class='apply'>
        <div class="title" :class="$vuetify.theme.dark ? '': 'sub-title-l'">{{$t('preference.timeFrame.title')}}</div>
        <div id="timeFrame" style="flex: 1;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { reportAuthTime } from "@/api/index";
import monent from 'moment'
import store from '@/store'
export default {
    data() {
        return {

        };
    },
    props:{
        filterQuery:{
            type:Number,
            default:1
        }
    },
    watch:{
        filterQuery:{
            handler:function (val, oldVal) {
                this.initTimeFrame()
            },
        }

    },
    mounted() {
        this.initTimeFrame()
    },
    methods: {
        initTimeFrame(){
            let startTime = monent().subtract(1,'w').startOf('days').unix()
            let endTime = monent().endOf('days').unix()
            // let endTime = monent().unix()
            if(this.filterQuery == 1){
                startTime = monent().subtract(6,'days').startOf('days').unix()
            }
            if(this.filterQuery == 2){
                startTime = monent().subtract(13,'days').startOf('days').unix()
            }
            if(this.filterQuery == 3){
                startTime = monent().subtract(20,'days').startOf('days').unix()
            }
            if(this.filterQuery == 4){
                startTime = monent().subtract(29,'days').startOf('days').unix()
            }
            if(this.filterQuery == 5){
                startTime = monent().subtract(59,'days').startOf('days').unix()
            }
            if(this.filterQuery == 6){
                startTime = monent().subtract(89,'days').startOf('days').unix()
            }

            let params = {
                startTime:startTime,
                endTime:endTime
            }
            reportAuthTime(params).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    let list = []
                    let list2 = []
                    res.data = res.data.sort((a,b) => {return parseInt(a.name) > parseInt(b.name)?1:-1;})
                    for (let item of res.data) {
                        list.push(item.name)
                        list2.push(item.value)
                    }
                    this.setEcharts(list, list2)
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        setEcharts(list, list2) {
            var chartDom = document.getElementById('timeFrame');
            var myChart = echarts.init(chartDom);
            var option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list,
                  axisLabel:{
                    color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
                  },
                },
                yAxis: {
                    type: 'value',
                    axisLabel:{
                      color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
                    },
                },
                tooltip: {
                    formatter: "{b}"+this.$t('preference.time')+': {c}('+this.$t('preference.num')+")"
                },
                series: [
                    {
                        data: list2,
                        type: 'line',
                        areaStyle: {
                            color: '#B3C9FB'
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#5066ed' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#5066ed' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        },
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>

<style lang='scss' scoped>
.apply {
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 500;
        padding-left: 33px;
        border-bottom: 1px solid #F0F0F0;
    }
    .sub-title-l {
        color: #031b4e;
    }
}
</style>
